import { put, takeLatest, call } from 'redux-saga/effects';

import Immutable from 'seamless-immutable';

import { formatError } from '../../../libs';
import appAPI from '../../api/app';
import { Types, Creators as AppCreators } from '../../reducers/app';

function extractFooter(array) {
  const footerData = {};

  array.map((child) => {
    switch (child.title) {
      case 'Rodape':
        footerData.helpSupport = child.children;
        break;
      case 'Redes':
        footerData.socials = child.getIn(['children', 0, 'children']);
        break;

      case 'SmartRow':
        footerData.socialPlugin = child.children;
        break;

      default:
        break;
    }
    return null;
  });

  return footerData;
}

function* menuCategoryRequest({ siteId }) {
  try {
    const data = yield call(appAPI.getCategories, siteId);

    const validData = {
      header: {
        top: Immutable(data).getIn(['top', 'component', 'children', 0], {}),
        menu: Immutable(data).getIn(['menu', 'component', 'children', 0, 'children'], []),
        menuTop: Immutable(data).getIn(['menuTop', 'component', 'children'], []),
      },
      footer: {
        ...extractFooter(Immutable(data).getIn(['footer', 'component', 'children'], [])),
        department: Immutable(data).getIn(['menu', 'component', 'children', 0, 'children'], []),
        description: Immutable(data).getIn(['footerDescription', 'component', 'content'], ''),
      },
    };

    yield put(AppCreators.menuCategorySuccess(validData));
  } catch (error) {
    yield put(AppCreators.menuCategoryError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.MENU_CATEGORY_REQUEST, menuCategoryRequest);
}
